module.exports = __webpack_public_path__ + "static/media/063-money.7287e893.svg";